import React, { useState, useEffect } from "react";
import HeaderLeft from "./HeaderLeft";
import { useNavigate } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { Formik } from "formik";
import Modal from "react-bootstrap/Modal";
import download from "../assets/images/attach_file_black_2.png";
import { SpinnerCircular } from "spinners-react";

function UploadPracticeVideos() {
  const token = GetStorage.get("xAuthToken");
  let user = localStorage.getItem("user");
  user = JSON.parse(user);
  const [error, setError] = useState("");
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");
  const [value, setValues] = useState("0");
  const [message, setMessage] = useState("");
  const handleShow = () => setShow(true);
  const [uploadSpin, setUploadSpin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = GetStorage.get("user");
    if (user.data.is_submitted === 1) {
      navigate("/backHome");
    }
    checkVideo();
  }, []);

  const checkVideo = () => {
    http
      .get(`api/analyst/bucket?token=${token}`)
      .then((res) => {
        console.log("response", res.data);
        if (res.data.length === 0) {
          return;
        } else {
          navigate("/uploadNewPracticeVideo");
        }
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };

  const [inputText, setInputText] = useState("");

  const handleChanges = (event) => {
    console.log("video url===>", event.target.files[0].name);
    setName(event.target.files[0].name);
    const val = event.target.files[0];
    setValues(val);
  };
  const [showModal, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setError("");
    setName("");
  };

  const validFormats = [
    "video/mp4",             // .mp4
    "video/quicktime",       // .mov
    "video/x-msvideo",       // .avi
    "video/x-ms-wmv",        // .wmv
    "video/x-flv",           // .flv
    "video/mpeg",            // .mpeg
    "video/x-matroska",      // .mkv
    "video/3gpp",            // .3gp
    "video/3gpp2",           // .3g2
    "video/ogg",             // .ogg
    "video/webm",            // .webm
    "video/vnd.sealed.mpeg4",// Sealed MPEG4
    "video/mp2t",            // .ts
    // "application/octet-stream" // Generic binary file
  ];

  const handleUpload = (values) => {
    // if (value.type !== "video/mp4") {
    if (!validFormats.includes(value.type)) {
      setError("Invalid file format. Please upload a valid video file.");
      return;
    } else {
      setError("");
    }
    setUploadSpin(true);
    http
      .post(`public/analyst/s3video?token=${token}`, {
        // file_type: "video/mp4",
        file_type: value.type,
        file_name: inputText,
      })
      .then((res) => {
        setUploadSpin(false);

        console.log("response", res.data);
        const { url, key } = res.data.result;
        console.log(url, key);
        setUrl(key);
        fetch(url, {
          body: value,
          method: "PUT",
          headers: {
            "content-type": value.type,
            Accept: "*/*",
          },
        });
        handleClose();
        navigate("/uploadNewPracticeVideo");
      })
      .catch((error) => {
        setUploadSpin(false);

        console.log("error ", error.response.data.errors);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section className="otp_verification custom_hight">
        <div className="login_inner">
          <h1 className="mb_30 main_title ">{user.data.firstname} {user.data.lastname}</h1>
          <p className="mb_40 them_para text-center mx-auto text_limit">
            Please upload your sample practice evo videos so that we can review
            them and proceed with the application
          </p>
          <h6 className="sub_title mb_30">Step 2: Upload Practice Video(s)</h6>
          <div className="btn_wraper"></div>
          <div className="upload-btn-wrapper btn_wraper">
            <button className="them_btn mt_40 mb_30" onClick={handleShow}>
              Upload
            </button>
          </div>
        </div>
      </section>
      <Modal className="starrating" show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title as="h5">Upload Video</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="">
              <div className="form-group  mt-3">
                <input
                  onChange={(e) => {
                    setInputText(e.target.value);
                  }}
                  className="custom_input w-95  form-control"
                  placeholder="Enter text"
                />
              </div>

              <div className="form-group vedio_modal_file icon mt-3 w-100">
                <div className="upload-btn-wrapper">
                  <button className="btn">Upload a file</button>

                  <input type="file" name="myfile" onChange={handleChanges} />

                  <div className="img_icon">
                    <a href="">
                      <img src={download} alt="" />{" "}
                    </a>
                  </div>
                </div>
                <p style={{ marginLeft: 20 }}>{name}</p>
              </div>
            </div>

            <div className="modal-footer border-top-0">
              {" "}
              <button
                type="button"
                className="them_btn_ouline "
                onClick={handleClose}
              >
                Cancel
              </button>{" "}
              <button
                type="button"
                className="them_btn "
                onClick={handleUpload}
              >
                {uploadSpin ? (
                  <SpinnerCircular className="button-spin" />
                ) : (
                  "  Upload"
                )}
              </button>
            </div>
            <h5 style={{ color: "green" }}>{message}</h5>
            <h5 style={{ color: "red" }}>{error}</h5>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UploadPracticeVideos;
